import { useFpB2bCartCalculate } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-calculate'
import { OrderDetail } from '@cart-ui/OrderDetail/OrderDetail'
import { Fade } from '@pets-ui/Fade/Fade'
import { Paper } from '@pets-ui/Paper/Paper'
import { useStmCart } from '../CartProvider'

export const CardOrderDetail = () => {
  const { campaignId, campaignCode, currency, countryCode, platform } = useStmCart()
  const { calculateResult } = useFpB2bCartCalculate(campaignId, campaignCode, platform)

  return (
    <Paper elevation={0} borderRadius={8}>
      <Fade in>
        <OrderDetail
          discountItems={calculateResult?.discount_items || []}
          subtotal={calculateResult?.subtotal ?? 0}
          subtotalAfterDiscount={calculateResult?.total_without_addon_v2 ?? 0}
          shippingTotal={calculateResult?.shipping_total ?? 0}
          total={calculateResult?.total ?? 0}
          addonV2Total={calculateResult?.addon_v2_total ?? 0}
          currency={currency || 'TWD'}
          tax={calculateResult?.tax ?? 0}
          countryCode={countryCode}
          addonV2TotalBeforeDiscount={calculateResult?.addon_v2_total_before_discount ?? 0}
        />
      </Fade>
    </Paper>
  )
}
